import React from "react";
import PropTypes from "prop-types";

const styles = {
  chaseTable: {
    padding: 0,
    margin: 0,
    boxShadow: "3px 3px 3px #bbb",
    width: "100%",
  },
  gameHeader: {
    padding: 0,
    margin: 0,
    color: "#FFF",
    backgroundColor: "#06b",
    fontSize: 14,
    fontWeight: "bold",
  },
  gameHeaderData: {
    padding: 10,
  },
  gameHeaderMain: {
    fontSize: 16,
    backgroundColor: "#06b",
    color: "#fff",
    fontWeight: "bold",
  },
  gameHeaderMainHeader: {
    padding: 10,
  },
  rowGame: {
    fontSize: 15,
    color: "#02243C",
  },
  rowGameEven: {
    backgroundColor: "#EEE",
  },
  rowGameOdd: {
    backgroundColor: "#FFF",
  },
  rowGameData: {
    padding: 4,
    textAlign: "center",
    borderRight: "1px solid #DDD",
    borderBottom: "1px solid #DDD",
  },
};
const isMobile = window.matchMedia("(max-device-width: 960px)").matches;
if (isMobile) {
  styles.gameHeaderMainHeader.fontSize = 40;
  styles.gameHeaderData.fontSize = 50;
  styles.rowGameData.fontSize = 35;
}

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight ||
        document.documentElement.clientHeight) /*or $(window).height() */ &&
    rect.right <=
      (window.innerWidth ||
        document.documentElement.clientWidth) /*or $(window).width() */
  );
}

class StickyTable extends React.Component {
  state = {
    chaseList: [],
    previousStickerState: true,
    columnDimensions: {
      agentWidth: 0,
      balanceWidth: 0,
      notesWidth: 0,
    },
  };
  handleScroll = () => {
    const { tableId, upperElementClass } = this.props;
    const header = document.getElementById(`chaselist-header-${tableId}`);
    const stickyHeader = document.getElementById(
      `chaselist-header-sticky-${tableId}`
    );
    const upperElement = document.getElementsByClassName(upperElementClass)[0];
    const isHeaderInViewPort = isElementInViewport(header);
    if (!isHeaderInViewPort && !this.state.previousStickerState) {
      stickyHeader.style.position = "fixed";
      stickyHeader.style.display = "table";
      const isUpperInViewPort = isElementInViewport(upperElement);
      if (isUpperInViewPort) {
        stickyHeader.style.top = `${upperElement.clientHeight}px`;
      } else {
        stickyHeader.style.top = `0px`;
      }
      this.setState({ previousStickerState: true });
    } else if (isHeaderInViewPort && this.state.previousStickerState) {
      this.setState({ previousStickerState: false });
      stickyHeader.style.position = "fixed";
      stickyHeader.style.display = "none";
    }
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  async componentDidMount() {
    const { tableId } = this.props;
    document.getElementById(
      `chaselist-header-sticky-${tableId}`
    ).style.display = "none";
    const tableHeader = document.getElementById(`chaselist-header-${tableId}`);
    const tableHeaderClone = document.getElementById(
      `chaselist-header-clone-${tableId}`
    );
    tableHeaderClone.innerHTML = tableHeader.innerHTML;
    window.addEventListener("scroll", this.handleScroll);
  }

  render() {
    const { headerRows, tableBody, tableId } = this.props;
    return (
      <div>
        <table
          id={`chaselist-header-sticky-${tableId}`}
          cellSpacing="0"
          cellPadding="5"
          border="0"
          style={{
            ...styles.chaseTable,
            width: this.state.containerWidth * 100,
            zIndex: 10,
          }}
        >
          <thead id={`chaselist-header-clone-${tableId}`} />
        </table>
        <table
          cellSpacing="0"
          cellPadding="5"
          border="0"
          style={{
            ...styles.chaseTable,
            width: this.state.containerWidth * 100,
          }}
        >
          <thead id={`chaselist-header-${tableId}`}>{headerRows}</thead>
          {tableBody}
        </table>
      </div>
    );
  }
}

StickyTable.propTypes = {
  tableId: PropTypes.string.isRequired,
  upperElementClass: PropTypes.string.isRequired,
  headerRows: PropTypes.array.isRequired,
  tableBody: PropTypes.object.isRequired,
};
export default StickyTable;
